import { createAction, props } from '@ngrx/store';
import { ProductResponse } from '@common/product-response';

export const loadAdminProducts = createAction(
  '[Admin Products] Load Admin Products',
  props<{ page: number, size: number }>()
);

export const loadAdminProductsSuccess = createAction(
  '[Admin Products] Load Admin Products Success',
  props<{ productResponse: ProductResponse }>()
);

export const loadAdminProductsFailure = createAction(
  '[Admin Products] Load Admin Products Failure',
  props<{ error: any }>()
);
